<script>
    import { getParams } from './utils.js';

    const params = getParams();

    let keyword = params.keyword;
    let date = params.date;
</script>

<div class=" bg-blueish-black border-4 rounded-lg left-10 space-x-2 p-3">
    <p class="text-white pl-2">Keyword</p>
    <h1 class="text-white font-bold text-2xl pb-5">{keyword}</h1>
    <p class="text-white">Date</p>
    <h1 class="text-white font-bold text-2xl pb-5">{date}</h1>
</div>